import Honeybadger from "@honeybadger-io/js"

import { safeHoneybadgerNotify } from "./honeybadgerNoiseFilter"

type FilestackFailedFile = {
  filename?: string
  mimetype?: string
  size?: number
  source?: string
  uploadId?: string
  handle?: string
  originalFile?: {
    name?: string
    type?: string
    size?: number
  }
  [key: string]: unknown
}

/**
 * Report Filestack picker upload failures to Honeybadger.
 * Filestack's UI only shows a generic "email support" message; without this we have no prod signal.
 */
export function reportFilestackUploadFailure(
  file: FilestackFailedFile | null | undefined,
  context: Record<string, unknown> = {}
): void {
  const original = file?.originalFile || {}
  const filename = file?.filename || original.name || "unknown file"
  const error = new Error(`Filestack upload failed: ${filename}`)
  error.name = "FilestackUploadError"

  safeHoneybadgerNotify(Honeybadger, error, {
    context: {
      feature: "filestack_upload",
      filename,
      mimetype: file?.mimetype || original.type || null,
      size: file?.size ?? original.size ?? null,
      source: file?.source || null,
      uploadId: file?.uploadId || null,
      handle: file?.handle || null,
      ...context
    }
  })
}
